<template>
  <v-dialog
      v-model="dialog"
      :width="dialogWidth"
      @keydown.enter.prevent="onenter"
  >
    <v-card
        class="resizable-card"
        :class="{ 'no-select': resizing }"
        :style="{ height: dialogHeight + 'px' }"
    >
      <v-card-title>
        <span class="headline">Item Order ({{ rules.name }})</span>
      </v-card-title>
      <v-card-text class="resizable-card__body">
        <v-row dense>
          <v-autocomplete
              v-model="model"
              :items="values"
              item-text="name"
              item-value="uid"
              label="Select Order:"
              hide-details
              return-object
          />
        </v-row>
      </v-card-text>
      <v-card-actions class="resizable-card__actions">
        <v-spacer/>
        <v-btn color="blue darken-1" text @click="cancel">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="save">Save</v-btn>
      </v-card-actions>
      <div class="resize-handle" @mousedown="startResize"></div>
    </v-card>
  </v-dialog>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {ItemOrder} from "@/modules/redactor/models/item-order/ItemOrder";

export default {
  name: "r-item-order-dropdown-dialog",
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: VueTypes.objectOf(ItemOrder),
    rules: ViewRules.READONLY,
    values: [],
    dialogWidth: 402,
    dialogHeight: 260,
    resizing: false,
    resizeStartX: 0,
    resizeStartY: 0,
    resizeStartWidth: 402,
    resizeStartHeight: 260,
    viewportPadding: 32
  }),
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.loadValues();
      this.model = this.normalizeModel(model);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    loadValues() {
      this.values = RedactorUtils.getItemOrders() || [];
    },

    normalizeModel(input) {
      if (!input) return null;

      if (input instanceof ItemOrder) {
        return input;
      }

      if (typeof input === "string") {
        const found = this.values.find(o => o.uid === input || o.key === input);
        if (found) return found;
      }

      return null;
    },

    save() {
      if (!this.model || typeof this.model.valid !== "function" || !this.model.valid()) {
        this.$alert("Invalid config!");
        return;
      }

      this.resolve && this.resolve(this.model);
      this.discard();
    },

    cancel() {
      this.reject && this.reject();
      this.discard();
    },

    discard() {
      this.dialog = false;
      this.stopResize();
    },

    startResize(e) {
      this.resizing = true;
      this.resizeStartX = e.clientX;
      this.resizeStartY = e.clientY;
      this.resizeStartWidth = this.dialogWidth;
      this.resizeStartHeight = this.dialogHeight;
      window.addEventListener("mousemove", this.onResize);
      window.addEventListener("mouseup", this.stopResize);
    },

    onResize(e) {
      if (!this.resizing) return;
      const dx = e.clientX - this.resizeStartX;
      const dy = e.clientY - this.resizeStartY;
      let newWidth = this.resizeStartWidth + dx;
      let newHeight = this.resizeStartHeight + dy;
      const minWidth = 300;
      const minHeight = 180;
      if (newWidth < minWidth) newWidth = minWidth;
      if (newHeight < minHeight) newHeight = minHeight;
      this.dialogWidth = newWidth;
      this.dialogHeight = newHeight;
    },

    stopResize() {
      if (!this.resizing) return;
      this.resizing = false;
      window.removeEventListener("mousemove", this.onResize);
      window.removeEventListener("mouseup", this.stopResize);
    }
  },
  created() {
    this.loadValues();
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.onResize);
    window.removeEventListener("mouseup", this.stopResize);
  }
};
</script>

<style scoped>
.resizable-card {
  position: relative;
  display: flex;
  flex-direction: column;
}
.resizable-card__body {
  flex: 1;
  overflow: auto;
}
.resizable-card__actions {
  flex-shrink: 0;
}
.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 14px;
  height: 14px;
  cursor: se-resize;
  border-right: 2px solid rgba(0, 0, 0, 0.3);
  border-bottom: 2px solid rgba(0, 0, 0, 0.3);
}
.no-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
</style>